import React, { useState, useEffect } from "react";
import narrative_image from "../../../../../../assets/new_id.png";
import narrative_fill from "../../../../../../assets/new_id_.png";
import teamsIcon from "../../../../../../assets/teams.png";
import emailIcon from "../../../../../../assets/email.png";
import meetingsIcon from "../../../../../../assets/meets.png";
import townhallIcon from "../../../../../../assets/townhall.png";
import linkedinIcon from "../../../../../../assets/linkedIn.png";
import { ChevronRight } from "lucide-react";

const STAKEHOLDER_IMG_SRC = narrative_image;

const channelsList = [
  {
    id: "email",
    icon: <img src={emailIcon} alt="Email" style={{ width: 29.43, height: 29.43 }} />,
    title: "Via Email",
    description: "Written Communication",
  },
  {
    id: "teams",
    icon: <img src={teamsIcon} alt="Teams" style={{ width: 29.43, height: 29.43 }} />,
    title: "Via Teams etc.",
    description: "Internal Messaging Platform",
  },
  {
    id: "meetings",
    icon: (
      <img src={meetingsIcon} alt="Meetings" style={{ width: 29.43, height: 29.43 }} />
    ),
    title: "Via Meetings",
    description: "Face to face conversations",
  },
  {
    id: "townhall",
    icon: (
      <img src={townhallIcon} alt="Townhall"style={{ width: 29.43, height: 29.43 }} />
    ),
    title: "Via Townhall etc.",
    description: "Conversation in a large public forum",
  },
  {
    id: "linkedin",
    icon: (
      <img src={linkedinIcon} alt="Linkedin" style={{ width: 29.43, height: 29.43 }} />
    ),
    title: "Via Linkedin etc.",
    description: "Online social media platform",
  },
];

const StakeholderChannelsScreen = ({
  title,
  selectedChannels = [],
  setSelectedChannels,
  otherChannel = "",
  setOtherChannel,
  onNextStep,
  isSaving = false,
}) => {
  // local state so typing does not re-render the whole widget on each key
  const [localOther, setLocalOther] = useState(otherChannel || "");

  // keep local state in sync when loading / restoring
  useEffect(() => {
    setLocalOther(otherChannel || "");
  }, [otherChannel]);

  const handleChannelToggle = (id) => {
    setSelectedChannels((prev) => {
      if (prev.includes(id)) {
        const next = prev.filter((cid) => cid !== id);
        if (id === "others") {
          setLocalOther("");
          setOtherChannel("");
        }
        return next;
      }
      if (prev.length >= 4) return prev;
      return [...prev, id];
    });
  };

  // debounce sync of localOther -> parent otherChannel
  useEffect(() => {
    if (!selectedChannels.includes("others")) return;
    const t = setTimeout(() => {
      setOtherChannel(localOther);
    }, 150);
    return () => clearTimeout(t);
  }, [localOther, selectedChannels, setOtherChannel]);

  const canContinue =
    selectedChannels.length > 0 ||
    (selectedChannels.includes("others") && localOther.trim() !== "");

  const handleContinue = () => {
    if (onNextStep) onNextStep();
  };

  return (
    <div className="w-full flex flex-col px-0">
      <h1
        style={{
          fontFamily: "Gotham, sans-serif",
          fontWeight: 350,
          fontStyle: "normal",
          fontSize: "32px",
          color: "#323232",
          letterSpacing: 0,
        }}
      >
        {title}
      </h1>
      <p
        style={{
          fontFamily: "Gotham, sans-serif",
          fontWeight: 325,
          fontStyle: "normal",
          fontSize: "16px",
          lineHeight: "165%",
          color: "#323232",
          letterSpacing: 0,
          marginBottom: 8,
        }}
      >
        Choose all the channels where you can catch the attention your high-influence stakeholders.
      </p>
      <div className="w-full mt-8 flex flex-row items-start gap-20">
        <div
          className="relative"
          style={{ width: "421.35px", height: "491.76px", flexShrink: 0 }}
        >
          <img
            src={STAKEHOLDER_IMG_SRC}
            alt="Stakeholder"
            className="w-full h-full object-contain"
            style={{ opacity: 1 }}
          />
          {/* Colored overlay on feet */}
          <img
                src={narrative_fill}
                alt="Progress fill"
                className="pointer-events-none select-none"
                style={{
                  position: "absolute",
                  left: "0px",
                  bottom: "-180px",
                  width: "100%",
                  height: "100%",
                  objectFit: "contain",
                }}
              />
          <div
            className="absolute z-10"
            style={{
              left: "50px",
              bottom: "46px",
              minWidth: 0,
              textAlign: "left",
            }}
          >
            <div className="flex flex-col">
              <span
                className="uppercase"
                style={{
                  fontFamily: "Gotham, sans-serif",
                  fontWeight: 500,
                  fontStyle: "normal",
                  fontSize: "12px",
                  lineHeight: "135%",
                  letterSpacing: 0,
                  color: "#454545",
                }}
              >
                MY NARRATIVE
              </span>
              <span
                className="uppercase"
                style={{
                  fontFamily: "Gotham, sans-serif",
                  fontWeight: 500,
                  fontStyle: "normal",
                  fontSize: "14px",
                  lineHeight: "135%",
                  letterSpacing: 0,
                  color: "#1DA4A2",
                }}
              >
                10% COMPLETE
              </span>
            </div>
            <div
              className="border-b"
              style={{
                width: "200.8px",
                borderColor: "#454545",
                marginTop: "2px",
              }}
            />
          </div>
        </div>
        <div className="flex-1 flex flex-col">
          <div style={{ 
            display: 'flex', 
            alignItems: 'baseline',
            gap: '8px',
            marginBottom: 8,
          }}>
            <h2
              style={{
                color: "#323232",
                fontFamily: "Gotham, sans-serif",
                fontWeight: 500,
                fontSize: "22px",
                lineHeight: "165%",
                margin: 0,
              }}
            >
              Where do your stakeholders see you?
            </h2>
            <span
              style={{
                color: "#5A5A5A",
                fontFamily: "Gotham, sans-serif",
                fontWeight: 325,
                fontSize: "14px",
                lineHeight: "165%",
              }}
            >
              (Select any 4)
            </span>
        </div>
         
          <div
            className="grid"
            style={{
              gridTemplateColumns: "repeat(3, 193px)",
              gap: "18px",
              width: "fit-content",
              marginBottom: "24px",
            }}
          >
            {channelsList.map((ch) => {
              const isSelected = selectedChannels.includes(ch.id);
              const isDisabled = selectedChannels.length >= 4 && !isSelected;
              return (
                <button
                  type="button"
                  key={ch.id}
                  onClick={() => handleChannelToggle(ch.id)}
                  disabled={isDisabled}
                  style={{
                    width: "193px",
                    height: "190px",
                    borderRadius: "10px",
                    border: "1.01px solid #CCCCCC",
                    background: "#F8F8F8",
                    boxSizing: "border-box",
                    padding: "16px 14px 16px 14px",
                    position: "relative",
                    transition: "border 0.15s, background 0.15s",
                    opacity: isDisabled ? 0.5 : 1,
                    pointerEvents: isDisabled ? "none" : "auto",
                  }}
                >
                  <div
                    style={{
                      position: "absolute",
                      top: "14px",
                      right: "14px",
                      zIndex: 10,
                    }}
                  >
                    <div
                      style={{
                        width: "15.97px",
                        height: "15.97px",
                        borderRadius: "4px",
                        border: `1.5px solid ${
                          isSelected ? "#186D6C" : "#CCCCCC"
                        }`,
                        background: isSelected ? "#186D6C" : "#FFF",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        transition: "border-color 0.2s, background 0.2s",
                      }}
                    >
                      {isSelected && (
                        <svg
                          width="13"
                          height="13"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="#fff"
                          strokeWidth={3}
                        >
                          <path
                            d="M5 13l4 4L19 7"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      )}
                    </div>
                  </div>
                  <div
                    style={{
                      marginBottom: "28px",
                      marginTop: "2px",
                      marginLeft: "2px",
                    }}
                  >
                    {ch.icon}
                  </div>
                  <div style={{ marginTop: "8px", textAlign: "left" }}>
                    <div
                      style={{
                        fontFamily: "Gotham, sans-serif",
                        fontWeight: 700,
                        fontSize: "17px",
                        lineHeight: "140%",
                        color: "#202124",
                        marginBottom: "2px",
                        textAlign: "left",
                      }}
                    >
                      {ch.title}
                    </div>
                    <div
                      style={{
                        fontFamily: "Gotham, sans-serif",
                        fontWeight: 325,
                        fontSize: "14px",
                        lineHeight: "140%",
                        color: "#202124",
                        opacity: 0.8,
                        marginTop: "6px",
                        textAlign: "left",
                      }}
                    >
                      {ch.description}
                    </div>
                  </div>
                </button>
              );
            })}
            {/* OTHERS CARD */}
            <button
              type="button"
              onClick={() => handleChannelToggle("others")}
              disabled={
                selectedChannels.length >= 4 &&
                !selectedChannels.includes("others")
              }
              style={{
                width: "193px",
                height: "190px",
                borderRadius: "10px",
                border: "1.01px solid #CCCCCC",
                background: "#F8F8F8",
                boxSizing: "border-box",
                padding: "16px 14px 16px 14px",
                position: "relative",
                transition: "border 0.15s, background 0.15s",
                opacity:
                  selectedChannels.length >= 4 &&
                  !selectedChannels.includes("others")
                    ? 0.5
                    : 1,
                pointerEvents:
                  selectedChannels.length >= 4 &&
                  !selectedChannels.includes("others")
                    ? "none"
                    : "auto",
                cursor:
                  selectedChannels.length >= 4 &&
                  !selectedChannels.includes("others")
                    ? "not-allowed"
                    : "pointer",
              }}
            >
              <div
                style={{
                  position: "absolute",
                  top: "14px",
                  right: "14px",
                  zIndex: 10,
                }}
              >
                <div
                  style={{
                    width: "15.97px",
                    height: "15.97px",
                    borderRadius: "4px",
                    border: `1.5px solid ${
                      selectedChannels.includes("others") ? "#186D6C" : "#CCCCCC"
                    }`,
                    background: selectedChannels.includes("others")
                      ? "#186D6C"
                      : "#FFF",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  {selectedChannels.includes("others") && (
                    <svg
                      width="13"
                      height="13"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="#fff"
                      strokeWidth={3}
                    >
                      <path
                        d="M5 13l4 4L19 7"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  )}
                </div>
              </div>
              <div
                style={{
                  marginBottom: "28px",
                  marginTop: "2px",
                  marginLeft: "2px",
                }}
              >
                <svg
                  width="32"
                  height="32"
                  fill="none"
                  stroke="#444444"
                  viewBox="0 0 24 24"
                  strokeWidth={2}
                >
                  <path
                    d="M12 5v14m7-7H5"
                    stroke="#444444"
                    strokeWidth={2}
                    strokeLinecap="round"
                  />
                </svg>
              </div>
              <div style={{ marginTop: "8px", textAlign: "left" }}>
                <div
                  style={{
                    fontFamily: "Gotham, sans-serif",
                    fontWeight: 700,
                    fontSize: "17px",
                    lineHeight: "140%",
                    color: "#202124",
                    marginBottom: "2px",
                    textAlign: "left",
                  }}
                >
                  Others
                </div>
                <div
                  style={{
                    fontFamily: "Gotham, sans-serif",
                    fontWeight: 400,
                    fontSize: "14px",
                    lineHeight: "140%",
                    color: "#202124",
                    opacity: 0.8,
                    marginTop: "6px",
                    textAlign: "left",
                  }}
                >
                  Events, Q&A etc.
                </div>
              </div>
            </button>
          </div>
          {selectedChannels.includes("others") && (
            <div className="mb-2 w-full" style={{ maxWidth: "500px" }}>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Please mention the platform / channel below
              </label>
              <input
                type="text"
                value={localOther}
                onChange={(e) => setLocalOther(e.target.value)}
                className="w-full border-b text-[17px] border-gray-300 px-2 mb-4 text-[#54B0AF] focus:outline-none focus:border-[#54B0AF]"
              />
            </div>
          )}

          <div className="pt-4 mb-2">
            <button
              onClick={handleContinue}
              disabled={!canContinue}
              className={`px-8 2xl:px-4 py-4 rounded-[17.82px] text-[17.01px]  font-medium font-gotham text-white flex justify-between items-center gap-2 transition ${
                canContinue
                  ? "bg-black hover:bg-[#222]"
                  : "bg-gray-300 cursor-not-allowed"
              }`}
            >
              Go to Next Step
               <span className="bg-white rounded-full p-2">
                <ChevronRight className="w-4 h-4 text-black" />
                </span>
              {/* <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                <path
                  fillRule="evenodd"
                  d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z"
                  clipRule="evenodd"
                />
              </svg> */}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StakeholderChannelsScreen;